import { getLocalDate } from './dateUtils';
import { getValueByDotNotation } from './objectUtils';

export const toLookup = (array, keyName = 'id') => (array
    ? array.reduce((prev, curr) => (
        curr ? { ...prev, [getValueByDotNotation(curr, keyName)]: curr } : prev
    ), {}) : {}
);

export const toLookupMultiple = (array, keyName = 'id', initialValue = {}) => (array
    ? array.reduce((prev, curr) => (
        { ...prev, [curr[keyName]]: [...prev[curr[keyName]] || [], curr] }
    ), initialValue || {}) : initialValue || {}
);

export const toBoolLookup = (array, keyName = '') => (array
    ? array.reduce((prev, curr) => (
        { ...prev, [keyName ? curr[keyName] : curr]: true }
    ), {}) : {}
);

export const GUID_LENGTH = 36;

export const toGuidLookup = (array, trimKey) => (array ? array.reduce((prev, curr) => (
    curr.startsWith(trimKey)
        ? { ...prev, [curr.slice(trimKey.length, GUID_LENGTH + trimKey.length)]: true }
        : prev
), {}) : {});

export const toCommaList = (array, keyName = 'name') => (array
    ? array.reduce((prev, curr) => (curr ? `${prev ? `${prev}, ` : ''}${curr[keyName]}` : prev), '') : null
);

export const findMax = (array, keyName, startValue = 0) => (array
    ? array.reduce((prev, curr) => (curr && curr[keyName] ? Math.max(prev, Number(curr[keyName]) || startValue) : prev), startValue) : startValue
);

export const findMaxDate = (array, keyName = 'created', startValue = null) => (array
    ? array.reduce((prev, curr) => (curr && curr[keyName] ? Math.max(prev, getLocalDate(curr[keyName]) || startValue) : prev), startValue) : startValue
);

export const reorderElements = (array, fromIndex, toIndex) => {
    const reordered = [...array];
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

export const insertAtIndex = (array, index, elementToInsert) => {
    const reordered = [...array];
    reordered.splice(index, 0, elementToInsert);
    return reordered;
};

export const sortByDate = (array, propName = 'created') => (array ? [...array].sort((a, b) => new Date(b[propName]) - new Date(a[propName])) : null);
export const sortByDateAscending = (array, propName = 'created') => (array ? [...array].sort((a, b) => new Date(a[propName]) - new Date(b[propName])) : null);
export const sortByString = (array, propName = 'name') => (array ? [...array].sort((a, b) => `${a[propName] || ''}`.localeCompare(b[propName])) : null);

const sortComp = (a, b) => (a > b) - (a < b);
const sortCompDate = (a, b) => new Date(a) - new Date(b);
export const sortByMany = (array, ...sortProps) => (array ? array.sort((a, b) => sortProps.reduce((prev, curr) => prev || sortComp(a[curr], b[curr]), 0)) : null);
export const sortByManyAdvanced = (array, ...sortProps) => (array ? [...array].sort((a, b) => sortProps.reduce((prev, curr) => prev || ((p) => {
    switch (p.type) {
    case 'date':
        return p.desc ? sortCompDate(b[p.name], a[p.name]) : sortCompDate(a[p.name], b[p.name]);
    case 'func':
        return p.desc ? p.sortFunc(b, a) : p.sortFunc(a, b);
    default:
        return p.desc ? sortComp(b[p.name], a[p.name]) : sortComp(a[p.name], b[p.name]);
    }
})(curr),
0)) : null);

export const distinct = (array, distinctBy = d => d.id) => {
    const set = {};
    return array?.filter((d) => { if (set[distinctBy(d)]) return false; set[distinctBy(d)] = true; return true; });
};

// Merge two arrays and filter out duplicates by key (item from B is preserved)
export const mergeWithFilter = (a, b, key = 'id') => {
    const bDict = toBoolLookup(b, key);
    return (a || []).filter(elem => !bDict[elem[key]])
        .concat(b || []);
};

export const reverse = (array) => {
    const clone = [...array];
    clone.reverse();
    return clone;
};

export const fillArrayToLength = (inputDataArray, fillLength, fillElement) => [...inputDataArray || [], ...Array(Math.max(fillLength - (inputDataArray?.length || 0), 0)).fill(fillElement)];
